import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { DevelopmentGuard } from "../zdevcontrols/development-guard.service";
import { Auth0LoginComponent } from "./auth0-login/auth0-login.component";
import { Auth0SelectUserComponent } from "./auth0-select-user/auth0-select-user.component";
import { LoginComponent } from "./login/login.component";
import { MfaComponent } from "./mfa/mfa.component";
import { SsoRedirectComponent } from "./sso-redirect/sso-redirect.component";
import { SsoComponent } from "./sso/sso.component";

const routes: Routes = [
  { path: "", component: LoginComponent },
  { path: "auth0", component: Auth0LoginComponent, canActivate: [DevelopmentGuard] },
  { path: "mfa", component: MfaComponent },
  { path: "sso", component: SsoComponent },
  { path: "sso-redirect", component: SsoRedirectComponent },
  { path: "select-user", component: Auth0SelectUserComponent, canActivate: [DevelopmentGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule { }
